// Rentang tanggal date-only (YYYY-MM-DD) untuk pencarian transaksi bank.
// Aritmetika via UTC agar tidak bergeser timezone; nilai ber-jam dikonversi ke Asia/Jakarta.

const ISO = /^\d{4}-\d{2}-\d{2}$/;

export function toJakartaDate(v) {
  if (!v) return null;
  const s = String(v).trim();
  if (ISO.test(s)) {
    const [y, m, d] = s.split("-").map(Number);
    const dt = new Date(Date.UTC(y, m - 1, d));
    return dt.getUTCFullYear() === y && dt.getUTCMonth() === m - 1 && dt.getUTCDate() === d ? s : null;
  }
  const dt = new Date(s);
  if (Number.isNaN(dt.getTime())) return null;
  return new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Jakarta", year: "numeric", month: "2-digit", day: "2-digit" }).format(dt);
}

function shift(iso, days) {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d + days)).toISOString().slice(0, 10);
}

export const RANGE_PRESETS = [["same", "Tanggal yang sama"], ["7", "±7 hari"], ["month", "Bulan transaksi"], ["30", "±30 hari"]];

// Tanpa tanggal valid → rentang kosong (FAT memilih sendiri; tidak pakai "hari ini").
export function rangeFor(txDate, preset = "7") {
  const base = toJakartaDate(txDate);
  if (!base) return { from: "", to: "" };
  if (preset === "same") return { from: base, to: base };
  if (preset === "month") {
    const [y, m] = base.split("-").map(Number);
    return { from: `${base.slice(0, 7)}-01`, to: new Date(Date.UTC(y, m, 0)).toISOString().slice(0, 10) };
  }
  const n = Number(preset);
  return { from: shift(base, -n), to: shift(base, n) };
}
